import { isEmpty } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TableContainer } from "../../../components/DashboardComps/Dashboard.styles";
import StyledTable from "../../../components/StyledTable/StyledTable";
import useReport from "../../../hooks/useReport";
import { useReportWrapper } from "../../../store/store";
import { underscoreToFlat } from "../../../utils/helpers";
import { doHandleTransform } from "../../../utils/helpers/incidentListUtils";
import { BigBoldText } from "../../User/dashboard/home/home.style";

const Logs = () => {
  const { incident } = useReportWrapper((state) => ({
    incident: state.incident,
  }));

  const [incidentId, setIncidentId] = useState<any>(incident?.Id);

  const { getIncidentLogsByIncidentId } = useReport({ incidentId: incidentId });

  const { isLoading: incidentLogLoading, data: incidentLogData } =
    getIncidentLogsByIncidentId;

  const navigate = useNavigate();

  let _incidentLogData = incidentLogData?.data?.data || [];

  if (_incidentLogData.length) {
    _incidentLogData = _incidentLogData.map((item: any) =>
      doHandleTransform(item)
    );
  }

  const tableIncidentLogData = _incidentLogData.map((item: any) => {
    return {
      ...item,
      incidentModifiedDate:
        moment(item.createdDate).format("DD MMM YYYY, h:mm:ss a") || "N/A",
      incidentEvent: underscoreToFlat(item.incidentEvent) || "N/A",
      fieldName: underscoreToFlat(item.newIncident?.[0]?.fieldName) || "N/A",
      fieldValue: item.newIncident?.[0]?.fieldValue || "N/A",
      oldType: "N/A",
      oldValue: "N/A",
      newType: "N/A",
    };
  });

  useEffect(() => {
    if (isEmpty(incident)) navigate("/");
    else {
      setIncidentId(incident?.Id);
    }
  }, [incident]);
  return (
    <div style={{ minHeight: "100vh" }} title="Audit Logs">
      <div className="mb-10 mt-20">
        <BigBoldText>Audit Logs</BigBoldText>
      </div>
      <TableContainer>
        <StyledTable
          showSearchBar
          half
          showDateComponent
          showFilterBtn
          tableCols={logCols}
          tableData={tableIncidentLogData}
          isLoading={incidentLogLoading}
        />
      </TableContainer>
    </div>
  );
};

export default Logs;

export const logCols = [
  {
    Header: "Username",
    accessor: "contact",
  },
  {
    Header: "Time Stamp",
    accessor: "incidentModifiedDate",
  },
  {
    Header: "Field",
    accessor: "fieldName",
  },
  {
    Header: "Old Type",
    accessor: "oldType",
  },
  {
    Header: "Old Value",
    accessor: "oldValue",
  },
  {
    Header: "New Type",
    accessor: "newType",
  },
  {
    Header: "New Value",
    accessor: "fieldValue",
  },
  {
    Header: "Type",
    accessor: "incidentEvent",
  },
];
